export const DATE_LAST_UPDATE = "2022-06-19";
export const MAX_RECENCY_HOURS = 24;

export const URL_APP = "https://nuuuwan.github.io/fuel_lk_app/";
